<template>
  <div class="button-container" :style="`width:${dispW}px;height:${dispH}px`">
    <el-button
      icon="el-icon-position"
      @click="changeMode('select')"
      :style="`background:${backcolors['select']}`"
    ></el-button>
    <el-button
      icon="el-icon-right"
      @click="changeMode('measure')"
      :style="`background:${backcolors['measure']}`"
    ></el-button>
    <el-button
      icon="el-icon-rank"
      @click="changeMode('move')"
      :style="`background:${backcolors['move']}`"
    ></el-button>
    <div
      class="el-button el-button--default"
      @click="changeMode('rotate')"
      :style="`background:${backcolors['rotate']}`"
    >
      <i class="el-icon-">
        <svg width="30" height="25">
          <line x1="4" y1="4" x2="13" y2="12" style="stroke: white; stroke-width: 2" />
          <circle cx="4" cy="4" r="3" stroke="black" stroke-width="0" fill="white" />
          <line
            x1="13"
            y1="12"
            x2="23"
            y2="20"
            style="stroke: white; stroke-width: 2"
            stroke-dasharray="3 2"
          />
          <circle cx="23" cy="20" r="3" stroke="black" stroke-width="0" fill="white" />
          <line
            x1="23"
            y1="4"
            x2="13"
            y2="12"
            style="stroke: white; stroke-width: 2"
            stroke-dasharray="3 2"
          />
          <circle cx="23" cy="4" r="3" stroke="black" stroke-width="0" fill="white" />
          <line x1="13" y1="12" x2="4" y2="20" style="stroke: white; stroke-width: 2" />
          <circle cx="4" cy="20" r="3" stroke="black" stroke-width="0" fill="white" />
        </svg>
      </i>
    </div>
  </div>
</template>
<script>
import { TOPOGRAPHYEVENTS } from "../shared/events";
export default {
  name: "RGPButtons",
  created() {
    this.$bus.$on(TOPOGRAPHYEVENTS.rgpDrawModeInitted, (mode) => {
      this.mode = mode;
    });
  },
  mounted() {},

  data() {
    return {
      backcolors: {
        select: "transparent",
        measure: "gray",
        move: "gray",
        rotate: "gray"
      },
      mode: "select"
    };
  },
  methods: {
    changeMode(mode) {
      this.mode = mode;
      this.$bus.$emit(TOPOGRAPHYEVENTS.rgpDrawModeChanged, this.mode);
    }
  },
  props: {
    dispW: {
      type: Number,
      default: 50
    },
    dispH: {
      type: Number,
      default: 200
    }
  },
  watch: {
    mode: function () {
      for (let id in this.backcolors) {
        if (id === this.mode) {
          this.backcolors[id] = "transparent";
        } else {
          this.backcolors[id] = "gray";
        }
      }
    }
  },
  destroyed() {
    this.$bus.$off(TOPOGRAPHYEVENTS.rgpDrawModeInitted);
  }
};
</script>
<style scoped>
.button-container {
  position: flex;
  padding: 10px;
  border-radius: 10px;
  flex-direction: column;
}
.el-button {
  background: transparent;
  color: white;
  font-size: 30px;
  margin: 10px;
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-Buttons.vue